import script from "./sensitive.vue?vue&type=script&setup=true&lang=js"
export * from "./sensitive.vue?vue&type=script&setup=true&lang=js"

import "./sensitive.vue?vue&type=style&index=0&id=1e081c15&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e081c15"]])

export default __exports__